// identity.ts — player name + room-code helpers (persisted across visits).

const NAME_KEY = "dlam-name";

const ADJ = [
  "sunny", "violet", "mellow", "wild", "cosmic", "brave", "fuzzy", "neon",
  "lunar", "jade", "amber", "swift", "calm", "zesty", "dusty", "minty",
];
const NOUN = [
  "otter", "comet", "maple", "finch", "echo", "willow", "ember", "puffin",
  "drift", "koi", "luna", "fox", "reed", "wren", "tide", "moss",
];

function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)] as T;
}

function cap(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function randomName(): string {
  return `${cap(pick(ADJ))} ${cap(pick(NOUN))}`;
}

export function getStoredName(): string {
  try {
    return localStorage.getItem(NAME_KEY) ?? "";
  } catch {
    return "";
  }
}

export function setStoredName(name: string): void {
  try {
    localStorage.setItem(NAME_KEY, name);
  } catch {
    /* ignore (private mode) */
  }
}

/** Clean a user-entered name: trim, collapse whitespace, cap length. */
export function sanitizeName(raw: string): string {
  return raw.replace(/\s+/g, " ").trim().slice(0, 24);
}

/** A short, link-friendly random room code, e.g. "amber-fox-42". */
export function randomRoomId(): string {
  const n = Math.floor(Math.random() * 90 + 10);
  return `${pick(ADJ)}-${pick(NOUN)}-${n}`;
}

/** Parse /r/<id> from the path, or null on the lobby/root. */
export function roomIdFromPath(): string | null {
  const m = location.pathname.match(/^\/r\/([^/]+)/);
  return m && m[1] ? decodeURIComponent(m[1]) : null;
}
